import React, { useEffect, useRef } from "react";
import './explainer.css'
import { FiX } from "react-icons/fi";
import ArchitectureDiagram from "./ArchitectureDiagram";

const ExplainerModal = ({ explainer, onClose }) => {
    const closeRef = useRef(null);

    useEffect(() => {
        if (!explainer) return;
        const onKey = (e) => { if (e.key === "Escape") onClose(); };
        document.addEventListener("keydown", onKey);
        document.body.style.overflow = "hidden";
        if (closeRef.current) closeRef.current.focus();
        return () => {
            document.removeEventListener("keydown", onKey);
            document.body.style.overflow = "";
        };
    }, [explainer, onClose]);

    if (!explainer) return null;

    const { title, analogy, steps, summary, architecture } = explainer;

    return (
        <div className="ex-backdrop" onClick={onClose} role="dialog" aria-modal="true" aria-label={`How ${title} works, explained simply`}>
            <div className={`ex-modal term-window${architecture ? " ex-modal--wide" : ""}`} onClick={(e) => e.stopPropagation()}>
                <div className="term-titlebar">
                    <span className="term-dot red"></span>
                    <span className="term-dot yellow"></span>
                    <span className="term-dot green"></span>
                    <span className="term-path">{architecture ? "architecture --view" : "explain --simple"}</span>
                    <button ref={closeRef} className="ex-close" onClick={onClose} aria-label="Close">
                        <FiX/>
                    </button>
                </div>
                <div className="ex-body">
                    <h3 className="mono ex-title">{title}</h3>

                    {architecture ? (
                        <>
                            {summary && <p className="ex-summary">{summary}</p>}
                            <ArchitectureDiagram zone={architecture.zone} columns={architecture.columns}/>
                        </>
                    ) : (
                        <>
                            <p className="mono txt-muted ex-comment">{"// in plain English"}</p>
                            <p className="ex-analogy">{analogy}</p>
                            <div className="ex-flow" aria-hidden="true">
                                {steps.map((label, i) => (
                                    <React.Fragment key={label}>
                                        <div className="ex-node" style={{ animationDelay: `${i * 0.15}s` }}>
                                            <span className="ex-node-label mono">{label}</span>
                                        </div>
                                        {i < steps.length - 1 && (
                                            <div className="ex-link">
                                                <span className="ex-packet"></span>
                                            </div>
                                        )}
                                    </React.Fragment>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ExplainerModal
